<template>
    <div class="order">
        <div class="order-header flex">
            <div class="order-header-item"
                v-for="(item, index) in tabList" :key="index"
                :class="{active: activeTab === index}"
                @click="switchTab(index)">
                {{item}}
            </div>
        </div>

        <div class="tableStyle flex">
            <div class="query">
                <el-form :inline="true" size="medium">
                    <el-form-item label="商品名称：" class="screen">
                        <el-input v-model="query.name" placeholder="请输入商品名称"></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号：" class="screen">
                        <el-input v-model="query.order_no" placeholder="请输入订单编号"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态" class="screen">
                        <el-select v-model="query.status" placeholder="请选择">
                        <el-option label="区域一" value="shanghai"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="买家昵称：" class="screen">
                        <el-input v-model="query.nickname" placeholder="请输入买家昵称"></el-input>
                    </el-form-item>
                    <el-form-item label="下单时间：" class="screen">
                        <el-date-picker
                            v-model="datePicker"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    
                    <el-form-item>
                        <el-button type="primary">查询</el-button>
                        <el-button>重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="order-table">
                <!-- <el-scrollbar> -->
                    <div class="order-table-item">
                        <div class="header">
                            <span class="orderNo">
                                订单编号：224087558086  
                            </span>
                            <span class="orderTime">
                                下单时间：2020-08-23 12:24:03
                            </span>
                        </div>
                        <div class="body flex">
                            <div class="goodsInfo body-item flex">
                                <el-image
                                    style="width: 100px; height: 100px"
                                    src="./../../assets/img/chargeH5Bg.png" 
                                    :preview-src-list="['./../../assets/img/chargeH5Bg.png']"
                                    fit="contain">
                                </el-image>
                                <span class="goodsInfo-name">
                                    Apple Watch SE
                                </span>
                            </div>
                            <div class="consigneeInfo body-item flex">
                                <span>马化腾</span>
                                <span>TEL: 151****6789</span>
                                <span class="address">中国江苏省玄武区梅园新村街道56号</span>
                            </div>
                            <div class="priceInfo body-item flex">
                                <div class="price priceInfo-item">
                                    ￥699.00*3 <span class="deliveryFee">（含配送费：￥5.00）</span>
                                </div>
                                <div class="pay-method priceInfo-item">余额支付</div>
                            </div>
                            <div class="statusInfo body-item flex">
                                <div class="status statusInfo-item">等待买家付款</div>
                                <div class="detail statusInfo-item" @click="goDetail">订单详情</div>
                                <div class="close statusInfo-item">关闭交易</div>
                            </div>
                        </div>
                    </div>
                    <div class="order-table-item">
                        <div class="header">
                            <span class="orderNo">
                                订单编号：224087558086  
                            </span>
                            <span class="orderTime">
                                下单时间：2020-08-23 12:24:03
                            </span>
                        </div>
                        <div class="body flex">
                            <div class="goodsInfo body-item flex">
                                <el-image
                                    style="width: 100px; height: 100px"
                                    src="./../../assets/img/chargeH5Bg.png" 
                                    :preview-src-list="['./../../assets/img/chargeH5Bg.png']"
                                    fit="contain">
                                </el-image>
                                <span class="goodsInfo-name">
                                    Apple Watch SE
                                </span>
                            </div>
                            <div class="consigneeInfo body-item flex">
                                <span>马化腾</span>
                                <span>TEL: 151****6789</span>
                                <span class="address">中国江苏省玄武区梅园新村街道56号</span>
                            </div>
                            <div class="priceInfo body-item flex">
                                <div class="price priceInfo-item">
                                    ￥699.00*3 <span class="deliveryFee">（含配送费：￥5.00）</span>
                                </div>
                                <div class="pay-method priceInfo-item">余额支付</div>
                            </div>
                            <div class="statusInfo body-item flex">
                                <div class="status statusInfo-item">等待买家付款</div>
                                <div class="detail statusInfo-item">订单详情</div>
                                <div class="close statusInfo-item">关闭交易</div>
                            </div>
                        </div>
                    </div>
                    <div class="order-table-item">
                        <div class="header">
                            <span class="orderNo">
                                订单编号：224087558086  
                            </span>
                            <span class="orderTime">
                                下单时间：2020-08-23 12:24:03
                            </span>
                        </div>
                        <div class="body flex">
                            <div class="goodsInfo body-item flex">
                                <el-image
                                    style="width: 100px; height: 100px"
                                    src="./../../assets/img/chargeH5Bg.png" 
                                    :preview-src-list="['./../../assets/img/chargeH5Bg.png']"
                                    fit="contain">
                                </el-image>
                                <span class="goodsInfo-name">
                                    Apple Watch SE
                                </span>
                            </div>
                            <div class="consigneeInfo body-item flex">
                                <span>马化腾</span>
                                <span>TEL: 151****6789</span>
                                <span class="address">中国江苏省玄武区梅园新村街道56号</span>
                            </div>
                            <div class="priceInfo body-item flex">
                                <div class="price priceInfo-item">
                                    ￥699.00*3 <span class="deliveryFee">（含配送费：￥5.00）</span>
                                </div>
                                <div class="pay-method priceInfo-item">余额支付</div>
                            </div>
                            <div class="statusInfo body-item flex">
                                <div class="status statusInfo-item">等待买家付款</div>
                                <div class="detail statusInfo-item">订单详情</div>
                                <div class="close statusInfo-item">关闭交易</div>
                            </div>
                        </div>
                    </div>
                <!-- </el-scrollbar> -->
            </div>
            <div class="pageFoot flex">
                <div class="tongji">
                    统计：共0条
                </div>
                <el-pagination
                    layout="total, prev, pager, next, sizes"
                    background
                    :page-size="query.size"
                    :total="total"
                    :page-sizes="[10, 20, 50, 100]"
                    @size-change="sizeChange"
                    @current-change="changePage">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tabList: [
                '近三个月订单',
                '等待买家付款',
                '买家已付款',
                '等待买家收货',
                '退款中',
                '交易成功',
                '交易关闭',
            ],
            activeTab: 0,
            query: {
                page: 1,
                size: 10,
                name: '',
                order_no: '',
                status: '',
                nickname: '',
                start_time: '',
                end_time: '',
            },
            total: 0,
            datePicker: '',
            orderTable: [
                {
                    id: 1,
                    order_no: '224087558086',
                    stamp: '2020-08-23 12:24:03',
                    goodsInfo: {
                        name: 'Apple Watch SE',
                        price: '699.00',
                        freight: '5.00',
                        cover: '',
                    },
                    consigneeInfo: {
                        name: '',
                        phone: '15059255925',
                        address: '中国江苏省玄武区梅园新村街道天安门'
                    },
                    status: 1,
                    payMode: '',
                }
            ],
        }
    },
    created() {
        
    },
    methods: {
        switchTab(index){
            if(this.activeTab === index){
                return;
            }else{
                this.activeTab = index;
            }
        },
        sizeChange(val){
            this.query.size = val;
        },
        changePage(val){
            this.query.page = val;
        },
        goDetail(){
            let route = {
                name: '订单详情',
                path: {path: '/main/mallOrderDetail'}
            };
            this.$store.commit('setTag', route);
            this.$router.push({
                name: 'MallOrderDetail',
                params: {
                    id: 1
                }
            });
        }
    },
}
</script>
<style lang="less" scoped>
    /deep/.el-range-input{
        background-color: transparent;
    }
    .order{
        height: 100%;
        .order-header{
            align-items: center;
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid #ebeef2;

            .order-header-item{
                margin-left: 68px;
                padding: 0 14px;
                // height: calc(100% - 1px);
                height: 100%;
                font-size: 16px;
                color: #333;
                border-bottom: 1px solid transparent;
                cursor: pointer;

                &.active,
                &:hover{
                    color: #0C78D7;
                    border-color: #0C78D7;
                }
                &:first-of-type{
                    margin-left: 0;
                }
            }
        }

        .tableStyle{
            flex-direction: column;
            height: calc(100% - 61px);
        }

        .order-table{
            flex: 1;
            min-height: calc(100% - 185px);
            // border-bottom: 1px solid #F4F5F7;
            overflow-y: scroll;
            /deep/.el-scrollbar{
                height: 100%;
                .el-scrollbar__wrap{
                    height: 100%;
                }
            }
            .order-table-item{
                border: 1px solid #F4F5F7;
                // border-bottom: none;
                .header{
                    height: 49px;
                    line-height: 49px;
                    border-bottom: 1px solid #F4F5F7;
                    background-color: #fcfcfd;
                    font-size: 14px;
                    color: #333;

                    span{
                        margin-left: 20px;
                    }
                }
                .body{
                    height: 199px;
                    font-size: 14px;

                    .body-item{
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-start;
                        border-right: 1px solid #F4F5F7;

                        &.goodsInfo{
                            width: 199px;
                            align-items: center;
                            /deep/.el-image{
                                width: 120px;
                                height: 120px;
                            }
                            .goodsInfo-name{
                                margin-top: 20px;
                            }
                        }
                        &.consigneeInfo{
                            box-sizing: border-box;
                            width: 599px;
                            padding: 0px 50px;
                            span{
                                margin-bottom: 14px;
                            }
                            .address{
                                margin-bottom: 0;
                            }
                        }
                        &.priceInfo{
                            box-sizing: border-box;
                            padding: 0 50px;
                            width: 399px;
                            .price{
                                .deliveryFee{
                                    color: #666;
                                }
                            }
                            .pay-method{
                                margin-top: 14px;
                            }
                        }
                        &.statusInfo{
                            box-sizing: border-box;
                            padding: 0 50px;
                            border-right: none;

                            .statusInfo-item{
                                margin-top: 14px;
                                color: #0C78D7;
                                cursor: pointer;
                                &.status{
                                    color: #333;
                                    cursor: default;
                                }
                                &:first-of-type{
                                    margin-top: 0;
                                }
                            }
                        }
                    }
                }
            }
        }

        .pageFoot{
            align-items: center;
            justify-content: space-between;

            .tongji{
                font-size: 14px;
            }
        }
    }
</style>